import { LocationService as BaseLocationService } from '../../core';
export class LocationService extends BaseLocationService {
  constructor(location) {
    super(location);
    this.location = location;
    this.location.onChange(this.notifyListeners);
  }
  set(url, options) {
    var _this$location$to, _this$location;
    (_this$location$to = (_this$location = this.location).to) == null || _this$location$to.call(_this$location, url, options);
  }
}
//# sourceMappingURL=LocationService.js.map